import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const ticketPreviewModalStyles = StyleSheet.create({
	panel: {
		maxWidth: 700,
		width: '90vw',
		maxHeight: '82vh',
		padding: 0,
		overflow: 'hidden',
	},
	header: {
		padding: `${THEME.spacing.md}px ${THEME.spacing.xl}px ${THEME.spacing.md}px ${THEME.spacing.lg}px`,
		marginBottom: 0,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
	},
	headerRow: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	headerSubject: {
		...THEME.common.truncate,
		margin: 0,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
		lineHeight: 1.4,
		color: THEME.colors.text.main,
	},
	statusBadge: {
		display: 'inline-block',
		fontSize: THEME.typography.fontSizes.xxs,
		padding: `${THEME.spacing.xs / 2}px ${THEME.spacing.sm}px`,
		borderRadius: 12,
		fontWeight: THEME.typography.fontWeights.semibold,
		backgroundColor: THEME.colors.background.main,
		border: `1px solid ${THEME.colors.border.main}`,
		color: THEME.colors.text.light,
		flexShrink: 0,
	},
	body: {
		overflowY: 'auto',
		padding: THEME.spacing.lg,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	metaRow: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.md,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	metaLabel: {
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	previewText: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		lineHeight: 1.5,
	},
	threadList: {
		maxHeight: 400,
		overflowY: 'auto',
	},
	noThreads: {
		padding: `${THEME.spacing.md}px 0`,
		textAlign: 'center',
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	footer: {
		padding: THEME.spacing.lg,
		borderTop: `1px solid ${THEME.colors.border.light}`,
	},
	mergeError: {
		marginRight: 'auto',
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.danger.main,
	},
});
